<form *ngIf="form" [formGroup]="form">
  <h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ title }}</h2>
  <mat-dialog-content class="flex flex-col">
    <div formArrayName="rows">
      <div *ngFor="let row of rows.controls; let i = index"
           [formGroupName]="i"
           class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-1">
        <span class="flex-1 font-medium">{{ row.get('vin').value || ('Vehículo #' + row.get('vehicleId').value) }}</span>
        <mat-form-field class="flex-none">
          <mat-label>Importe</mat-label>
          <input matInput type="number" step="0.01" formControlName="importe" />
          <span matSuffix>&euro;</span>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancelar</button>
    <button color="primary" mat-flat-button (click)="confirm()" cdkFocusInitial>Guardar</button>
  </div>
</form>
